import React, { useContext, useState } from 'react';
import { Grid, Box, Button, TextField, Paper, Typography, Divider, Stack, FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import SaveIcon from '@mui/icons-material/Save';
import SettingsContext from '../../Context/SettingsContext';
import HelpIcon from '@mui/icons-material/Help';
import { simulateInfo, firmwareOutcomes } from '../../common/help-texts';
import { saveSettings } from '../../common/help-functions';

const Simulation = () => {
  const { settingsState, setSettingsState } = useContext(SettingsContext)
  const [ helpText, setHelpText ] = useState(null)
  const simulation = settingsState.simulation

  const showHelp = (field, value = simulation[field]) => {
    const info = simulateInfo[field]
    const valueDescription = typeof info.valueDescription === 'object' ? info.valueDescription[value] : info.valueDescription
    setHelpText({ description: info.description, valueDescription, value: field })
  }

  const changeValue = (field, value) => {
    setSettingsState({ ...settingsState, simulation: { ...simulation, [field]: value } })
    showHelp(field, value)
  }

  const textField = (field, label, props = {}) => (
    <TextField
      fullWidth
      label={label}
      size='small'
      name={field}
      value={simulation[field] ?? ''}
      InputLabelProps={{ shrink: true }}
      onChange={(e) => changeValue(field, e.target.value)}
      onClick={() => showHelp(field)}
      {...props}
    />
  )

  const selectField = (field, label, options) => (
    <FormControl fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select
        size='small'
        value={simulation[field] ?? options[0]}
        label={label}
        name={field}
        onChange={(e) => changeValue(field, e.target.value)}
        onMouseDown={() => showHelp(field)}
      >
        { options.map(x => <MenuItem key={x} value={x}>{x}</MenuItem>) }
      </Select>
    </FormControl>
  )

  return (
    <Box>
      <Grid container spacing={5}>
        <Grid item xs={3}>
          <Stack spacing={3}>
            <Typography color='primary' fontWeight='bold'>Diagnostics / log upload</Typography>
            {textField('diagnosticFileName', 'Diagnostic file name')}
            {selectField('httpUploadMethod', 'HTTP upload method', ['POST', 'PUT'])}
            {textField('diagnosticUploadTime', 'Extra delay before upload (s)', { type: 'number', inputProps: { min: 0 } })}
            {selectField('diagnosticStatus', 'Upload result', ['Auto', 'UploadFailed'])}
            <Typography color='primary' fontWeight='bold'>Firmware update</Typography>
            {selectField('firmWareStatus', 'Firmware update result', Object.keys(firmwareOutcomes))}
          </Stack>
        </Grid>
        <Grid item xs={3}>
          <Stack spacing={3}>
            <Typography color='primary' fontWeight='bold'>Charging</Typography>
            {textField('maxPowerW', 'Max power per connector (W)', { type: 'number', inputProps: { min: 0, step: 100 } })}
            {textField('batteryCapacityWh', 'EV battery capacity (Wh)', { type: 'number', inputProps: { min: 1000, step: 1000 } })}
            {textField('initialSoc', 'EV state of charge at plug-in (%)', { type: 'number', inputProps: { min: 0, max: 100 } })}
            <Typography color='primary' fontWeight='bold'>Unlock connector</Typography>
            {selectField('connectorOneUnlock', 'Connector 1 Unlock connector status', ['Unlocked', 'UnlockFailed'])}
            { Number(settingsState.mainSettings.numberOfConnectors) === 2
              ? selectField('connectorTwoUnlock', 'Connector 2 Unlock connector status', ['Unlocked', 'UnlockFailed'])
              : null
            }
          </Stack>
        </Grid>
        <Grid item xs={6}>
          {
            helpText === null
            ? null
            : <Paper sx={{p: 2}}>
                <Box display='flex' alignItems='center' justifyContent='space-between'>
                  <Typography fontWeight='bold' color='primary'>{helpText.value}</Typography>
                  <HelpIcon color='primary' />
                </Box>
                <Divider sx={{ mt: 0.5, mb: 1.5 }} />
                <Stack direction='row' spacing={2} sx={{pb: 1}} >
                  <Box sx={{ minWidth: 80 }}><Typography color='primary'>Field desc:</Typography></Box>
                  <Box>{ helpText.description }</Box>
                </Stack>
                <Stack direction='row' spacing={2} >
                  {
                    helpText.valueDescription
                      ? <><Box sx={{ minWidth: 80 }}><Typography color='primary'>Value desc:</Typography></Box><Box>{ helpText.valueDescription }</Box></>
                      : null
                  }
                </Stack>
              </Paper>
          }
        </Grid>
      </Grid>
      <Button sx={{mt: 3}} startIcon={<SaveIcon />} variant='contained' onClick={() => saveSettings(settingsState)}>Save</Button>
    </Box>
  )
}

export default Simulation
